export const REGEX_CONSTANT = Object.freeze({
  EMAIL:/^\w+([.-]?\w+)*\w+([_.-])*@\w+([._-]?\w+)*(\.\w{2,3})+$/,
  PHONE_NUMBER: /^[1-9][0-9]*$/,
  LNG_LAT :/^-?([0-9]{1,2}|1[0-7][0-9]|180)(\.[0-9]{1,30})?$/,
  INTEGER : /^[0-9]*$/,
  FLOAT: /^(?!-+\s*$)?([0-9]*[.])?[0-9]+$/,
  ROLE_ID: /^[A-Za-z0-9-_]+$/,
  DESCRIPTION: /^[A-Za-z0-9-_.:&/ %+()]+$/,
  JUST_NUMBER: /^[0-9]+$/,
  FAX:/^(\+?\d{1,}(\s?|\-?)\d*(\s?|\-?)\(?\d{2,}\)?(\s?|\-?)\d{3,}\s?\d{3,})$/,
  NIK: /[0-9]{16}/,
  JUST_LAT : /^-?([0-8]?[0-9]|90)(\.[0-9]{1,30})?$/,
  NPWP: /^(?:(0[0-9]{15})|([1-9]{1}[0-9]{5}((?:(0[1-9]|[12]\d|[4-6]\d|[37][01]))((0[1-9]|[1][0-2]))[0-9]{6}))|(?:[0-9]{15}))$/,
  CHAR:/^[a-zA-Z ]+$/
})